<template>
    <div class="widget widget-item-list widget-primary">
        <div class="widget-inner">
            <div class="row">
                <template v-if="loadcarousel">
                    <div class="col-12">
                        <template v-if="fullItems.length === 0">
                            <div class="row">
                                <div class="col-6 col-lg-3" v-for="n in 4">
                                    <article class="cmp cmp-product-thumb cmp-product-thumb--grid">
                                        <div class="article-inner">
                                            <div class="article-inner-image">
                                                <a>
                                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC" class="skelet-cat-image">
                                                </a>
                                            </div>
                                            <div class="article-inner-always">
                                                <div class="d-flex split">
                                                    <div class="prices">
                                                        <div class="price">
                                                                <span class="price-n skelet-price">
                                                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC">
                                                                </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <a class="name skelet-name">
                                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC">
                                                </a>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            </div>
                        </template>
                        <carousel :items-per-page="4">
                            <template slot="items" v-for="item in fullItems">
                                <category-item
                                    :loggedin="loggedin"
                                    :incategory="1"
                                    :wishlist="wishlist"
                                    :itemdocument="item"

                                        :key="item.id"
                                        :item-data="item.data"
                                        :decimal-count="$ceres.config.item.storeSpecial"
                                        :disable-carousel-on-mobile="false">
                                </category-item>
                            </template>
                        </carousel>
                    </div>
                </template>
                <template v-else>
                    <template v-if="fullItems.length === 0">
                        <div class="col-6 col-lg-3" v-for="n in count">
                            <article class="cmp cmp-product-thumb cmp-product-thumb--grid">
                                <div class="article-inner">
                                    <div class="article-inner-image">
                                        <a>
                                            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC" class="skelet-cat-image">
                                        </a>
                                    </div>
                                    <div class="article-inner-always">
                                        <div class="d-flex split">
                                            <div class="prices">
                                                <div class="price">
                                                        <span class="price-n skelet-price">
                                                            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC">
                                                        </span>
                                                </div>
                                            </div>
                                        </div>
                                        <a class="name skelet-name">
                                            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC">
                                        </a>
                                    </div>
                                </div>
                            </article>
                        </div>
                    </template>
                    <div class="col-6 col-lg-3" v-for="item in fullItems">

                        <category-item
                            :loggedin="loggedin"
                            :incategory="1"
                            :wishlist="wishlist"
                            :itemdocument="item"


                              :key="item.id"
                                :item-data="item.data"
                                :decimal-count="$ceres.config.item.storeSpecial"
                                :disable-carousel-on-mobile="false">
                        </category-item>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    export default
    {
        props:
            {
              loggedin:
                  {
                    type: Number,
                    default:0
                  },
              wishlist: {
                type:Object,
                default:() => {}
              },






                template:
                    {
                        type: String,
                        default: "#vue-show-items"
                    },
                free:
                    {
                        type:String,
                        default:null
                    },
                categoryid:
                    {
                        type:Number,
                        default:0
                    },
                loadcarousel:
                    {
                        type:Boolean,
                        default:true
                    }
            },
        data: function()
        {
            return{
                freeItems:[],
                fullItems:[]
            }
        },
        created:function()
        {
            this.umwandeln();
        },
        methods:
            {
                currentVariation: function()
                {
                    return ceresStore.getters[`${this.itemId}/currentItemVariation`];
                },
                umwandeln: function()
                {
                    if(this.free != null)
                    {
                        this.freeItems = JSON.parse(this.free);
                        this.getItems(this.freeItems);
                    }
                    else if (this.categoryid !== 0)
                    {
                        this.getCategoryItems(this.categoryid)
                    }
                },
                getCategoryItems:function(categoryid)
                {
                    let _self = this;

                    let myPromise = new Promise(function(myResolve, myReject) {
                        let req = new XMLHttpRequest();
                        req.open('GET', '/getrandomcatitems/'+categoryid+'/');
                        req.onload = function() {
                            if (req.status == 200) {
                                myResolve(req.response);
                            } else {
                                myReject("error");
                            }
                        };
                        req.send();
                    });

                    myPromise.then(
                        function(value)
                        {
                            let json = JSON.parse(value);
                            _self.fullItems = json.documents;
                        },
                        function(error) {
                            // console.log(error)
                        }
                    );
                },
                getItems:function(itemids)
                {
                    let _self   = this;
                    let data    = { items:itemids }


                    let myPromise = new Promise(function(myResolve, myReject)
                    {
                    $.ajax(
                        {
                            type: 'POST',
                            url: '/getitems/',
                            data: data,
                            success: function (data)
                            {
                                myResolve(data);
                            },
                            error: function (jqXHR, textStatus, errorThrown)
                            {
                                myReject("error");
                            }
                        })

                    });

                    myPromise.then(
                        function(value)
                        {
                            _self.fullItems = value;
                        },
                        function(error) {
                            // console.log(error)
                        }
                    );


                }
            },
        computed:
            {
                count: function()
                {
                    let _self = this;
                    if (_self.freeItems.length > 0)
                    {
                        return _self.freeItems.length;
                    }
                    else
                    {
                        return 0;
                    }
                }
            }
    }
</script>
